import React, { useEffect, useState } from "react";
import "../css/css_layouts/Header.css";
import { FaSearch, FaBars, FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import config from "../../config";
import { useTranslation } from 'react-i18next';

const Header = ({ toggleSidebar }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [userProfile, setUserProfile] = useState({});
  const [userType, setUserType] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [showIssuePrompt, setShowIssuePrompt] = useState(false);

  useEffect(() => {
    const userType = Cookies.get("userType");
    setUserType(userType);

    const fetchUserProfile = async () => {
      try {
        const token = Cookies.get("authToken");
        if (!token) throw new Error("Authentication token not found.");

        const response = await fetch(`${config.API_URL}/user/profile`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) throw new Error("Failed to fetch user profile");
        const data = await response.json();

        let profilePictureResponse = await fetch(
          `${config.API_URL}/user/profile-image`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (!profilePictureResponse.ok) {
          profilePictureResponse = await fetch(
            `${config.API_URL}/user/static/utils/resources/profile.jpg`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
        }

        const profilePictureBlob = await profilePictureResponse.blob();
        const profilePictureUrl = URL.createObjectURL(profilePictureBlob);

        setUserProfile({ ...data, profilePicture: profilePictureUrl });
      } catch (error) {
        console.error("Error fetching user profile:", error);
      }
    };

    fetchUserProfile();

    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleAddIssueClick = () => {
    if (["TSO Online", "Online TSO", "management"].includes(userType)) {
      navigate("/new-issue");
    } else {
      setShowIssuePrompt(true);
    }
  };

  const handleIssueResponse = (isNewIssue) => {
    setShowIssuePrompt(false);
    if (isNewIssue) {
      navigate("/create-issue");
    }
    // If not a new issue, do nothing (just close the modal)
  };

  return (
    <header className="header">
      {/* Hamburger menu for responsive sidebar */}
      <button className="hamburger" onClick={toggleSidebar}>
        <FaBars />
      </button>

      <div className="user-info">
        <div className="user-avatar">
          {userProfile.profilePicture ? (
            <img
              src={userProfile.profilePicture}
              alt="Profile"
              className="profile-img"
            />
          ) : (
            <div className="avatar-placeholder">
              {["TSO Online", "Online TSO", "management"].includes(userType)
                ? userProfile.calling_name
                : userProfile.customer_name}
            </div>
          )}
        </div>
        <div className="user-details">
          <h4>
            {["TSO Online", "Online TSO", "management"].includes(userType)
              ? userProfile.calling_name
              : userProfile.customer_name || ""}
          </h4>
          <p>{userProfile.type || ""}</p>
        </div>
      </div>

      <div className="header-actions">
        {/* Add New Issue Button */}
        {userType !== "management" && (
          <>
            {isMobile ? (
              <button className="add-issues-icon" onClick={handleAddIssueClick}>
                <FaPlus />
              </button>
            ) : (
              <button className="add-issues-btn" onClick={handleAddIssueClick}>
                + {t('addNewIssue')}
              </button>
            )}
          </>
        )}
      </div>

      {/* Issue Prompt Modal */}
      {showIssuePrompt && (
        <div className="issue-prompt-modal">
          <div className="issue-prompt-content">
            <h3>{t('title')}</h3>
            <p>{t('question')}</p>
            <div className="issue-prompt-buttons">
              <button
                className="prompt-btn secondary"
                onClick={() => handleIssueResponse(false)}
              >
                {t('recurringIssue')}
              </button>
              <button
                className="prompt-btn primary"
                onClick={() => handleIssueResponse(true)}
              >
                {t('newIssue')}
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;